export function isDefined<T>(item: T): item is NonNullable<T> {
    return typeof item !== 'undefined' && item !== null
}

export function isTruthy<T>(item: T): item is NonNullable<T> {
    return !!item
}
